import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useMemo, useRef } from "react";
import { useOption } from "../../context/OptionContext";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import { useExport } from "../../context/ExportContext";
import { FaSpinner } from "react-icons/fa6";
import MaxPainChart from "../MaxPainChart/MaxPainChart";
import axios from "axios";
import "./OptionPage.css";
import { BsDash } from "react-icons/bs";

const OptionPage = () => {
  const { symbol, type, securityId: paramSecurityId } = useParams();
  const formattedType = type?.toUpperCase();
  const formattedSymbol = symbol?.toUpperCase();
  const numericSecurityId = paramSecurityId ? Number(paramSecurityId) : null;
  const atmRef = useRef(null); //new for scroll
  const navigate = useNavigate();
  //   const [selectedExpiry, setSelectedExpiry] = useState("");
  const [selectedStrike, setSelectedStrike] = useState("");
  const [isSaved, setIsSaved] = useState(false); //to check is saved or not
  const {
    fetchBySymbol,
    loading,
    error,
    pcr,
    meta,
    expiries,
    optionData,
    selectedExpiry,
    setSelectedExpiry,
    resetOptionState,
    setExpiry,
    fetchByIndex,
    fetchByAsset,
  } = useOption();
  const { stockName, getNameBySymbol } = useMarketIndicators();
  const { saveOptionChain, downloadOptionCSV, downloadOptionExcel } =
    useExport();
  // useEffect(() => {
  //   if (symbol) {
  //     fetchBySymbol(symbol);
  //     getNameBySymbol(symbol);
  //   }
  // }, [symbol]);
  // useEffect(() => {
  //   if (!symbol || !type) return;

  //   fetchOptionData({
  //     symbol,
  //     type,
  //   });

  //   if (type === "STOCK") {
  //     getNameBySymbol(symbol);
  //   }
  // }, [symbol, type]);
  // useEffect(() => {
  //   if (!symbol) return;

  //   resetOptionState();
  // }, [symbol]);
  const companyName = stockName?.company;
  console.log("Error from option", error);
  // const fetchOptionData = async () => {
  //   if (!formattedSymbol || !formattedType) return;

  //   resetOptionState();

  //   if (formattedType === "INDEX") {
  //     await fetchByIndex(formattedSymbol);
  //     return;
  //   }

  //   await fetchBySymbol(formattedSymbol);
  //   await getNameBySymbol(formattedSymbol);
  // };

  // useEffect(() => {
  //   fetchOptionData();
  // }, [formattedSymbol, formattedType]);

  // const fetchOptionData = async () => {
  //   if (!formattedSymbol || !formattedType) return;

  //   // resetOptionState();

  //   if (formattedType === "INDEX") {
  //     await fetchByIndex(formattedSymbol);
  //     return;
  //   }

  //   await fetchBySymbol(formattedSymbol);
  //   await getNameBySymbol(formattedSymbol);
  // };
  // const fetchOptionData = async () => {
  //   if (!formattedSymbol || !formattedType) return;

  //   console.log("OptionPage sending symbol:", formattedSymbol);
  //   console.log("OptionPage sending type:", formattedType);

  //   if (formattedType === "INDEX") {
  //     await fetchByIndex(formattedSymbol);
  //     return;
  //   }

  //   await fetchBySymbol(formattedSymbol);
  //   await getNameBySymbol(formattedSymbol);
  // };
  const fetchOptionData = async () => {
    if (!formattedSymbol || !formattedType) return;

    console.log("OptionPage symbol:", formattedSymbol);
    console.log("OptionPage type:", formattedType);
    console.log("OptionPage securityId:", numericSecurityId);
    console.log("OptionPage securityId type:", typeof numericSecurityId);

    if (formattedType === "INDEX") {
      await fetchByIndex(formattedSymbol);
      return;
    }

    await Promise.all([
      fetchBySymbol({
        symbol: formattedSymbol,
        securityId: numericSecurityId,
      }),
      getNameBySymbol(formattedSymbol),
    ]);
  };
  // useEffect(() => {
  //   if (!formattedSymbol || !formattedType) return;

  //   fetchOptionData();
  // }, [formattedSymbol, formattedType]);
  useEffect(() => {
    if (!formattedSymbol || !formattedType) return;

    fetchOptionData();
  }, [formattedSymbol, formattedType, numericSecurityId]);
  console.log("expire data", expiries);
  console.log("Option Chain", optionData);
  const totalCallOI = pcr?.totalCallOI;
  const totalPutOI = pcr?.totalPutOI;
  console.log("Call Oi", totalCallOI);
  console.log("Put Oi", totalPutOI);

  console.log("PCR", pcr?.value);
  const underlying = optionData?.data?.last_price ?? 0;

  const oc = optionData?.data?.oc || {};

  const rows = Object.keys(oc)
    .map((strike) => {
      const ce = oc[strike]?.ce;
      const pe = oc[strike]?.pe;

      // -------- CALL --------
      const ceOIChange = ce?.previous_oi != null ? ce.oi - ce.previous_oi : 0;

      const ceOIPercent =
        ce?.previous_oi > 0
          ? +(((ce.oi - ce.previous_oi) / ce.previous_oi) * 100).toFixed(2)
          : 0;

      const ceLtpPercent =
        ce?.previous_close_price > 0
          ? +(
              ((ce.last_price - ce.previous_close_price) /
                ce.previous_close_price) *
              100
            ).toFixed(2)
          : 0;

      // -------- PUT --------
      const peOIChange = pe?.previous_oi != null ? pe.oi - pe.previous_oi : 0;

      const peOIPercent =
        pe?.previous_oi > 0
          ? +(((pe.oi - pe.previous_oi) / pe.previous_oi) * 100).toFixed(2)
          : 0;

      const peLtpPercent =
        pe?.previous_close_price > 0
          ? +(
              ((pe.last_price - pe.previous_close_price) /
                pe.previous_close_price) *
              100
            ).toFixed(2)
          : 0;

      return {
        strike: Number(strike),

        CE: ce
          ? {
              oi: ce.oi,
              oiChange: ceOIChange,
              oiPercent: ceOIPercent,
              volume: ce.volume,
              iv: ce.implied_volatility,
              ltp: ce.last_price,
              ltpPercent: ceLtpPercent, // ✅ NEW
            }
          : null,

        PE: pe
          ? {
              oi: pe.oi,
              oiChange: peOIChange,
              oiPercent: peOIPercent,
              volume: pe.volume,
              iv: pe.implied_volatility,
              ltp: pe.last_price,
              ltpPercent: peLtpPercent, // ✅ NEW
            }
          : null,
      };
    })
    // ✅ lowest → highest strike (NSE style)
    .sort((a, b) => a.strike - b.strike);
  const totCEVol = rows.reduce((sum, row) => sum + (row.CE?.volume || 0), 0);

  const totPEVol = rows.reduce((sum, row) => sum + (row.PE?.volume || 0), 0);

  const showValue = (value) => {
    return value && value !== 0 ? value : "-";
  };
  const showFormatted = (value, formatter) => {
    if (!value || value === 0) return "-";
    return formatter ? formatter(value) : value;
  };
  const formatNumber = (num) => {
    if (num % 1 !== 0) {
      return num?.toFixed(2);
    }
    return num;
  };

  //strike prices list
  const strikePrices = useMemo(() => {
    const oc = optionData?.data?.oc;
    if (!oc) return [];

    return Object.keys(oc)
      .map(Number)
      .sort((a, b) => a - b);
  }, [optionData]);
  const handleExpiryChange = async (e) => {
    const expiry = e.target.value;

    setSelectedStrike("");
    await setExpiry(expiry);
  };
  const handleStrikeChange = (e) => {
    setSelectedStrike(e.target.value);
    setSelectedExpiry("");
  };

  const filteredRows = useMemo(() => {
    if (!rows?.length) return [];

    // Strike selected → filter
    if (selectedStrike) {
      return rows.filter((row) => row.strike === Number(selectedStrike));
    }

    // No strike selected → show ALL rows
    return rows;
  }, [rows, selectedStrike]);
  // useEffect(() => {
  //   if (expiries?.length && !selectedExpiry) {
  //     setSelectedExpiry(expiries[0]);
  //   }
  // }, [expiries, selectedExpiry]);

  function calculateMaxPainFromRows(rows, underlying) {
    if (!rows?.length) return null;

    const validRows = rows.filter(
      (r) => (r.CE?.oi || 0) > 0 || (r.PE?.oi || 0) > 0,
    );

    if (!validRows.length) return null;

    const strikes = validRows.map((r) => r.strike);

    let minPain = Infinity;
    let maxPainStrike = null;

    strikes.forEach((strike) => {
      let pain = 0;

      validRows.forEach((row) => {
        const s = row.strike;
        const ceOI = row.CE?.oi || 0;
        const peOI = row.PE?.oi || 0;

        if (strike > s) pain += (strike - s) * ceOI;
        if (strike < s) pain += (s - strike) * peOI;
      });

      if (pain < minPain) {
        minPain = pain;
        maxPainStrike = strike;
      }
    });

    return maxPainStrike;
  }
  const maxPain = calculateMaxPainFromRows(rows, underlying);

  const ceMaxRow = rows.find((r) => r.strike === maxPain)?.CE;
  const peMaxRow = rows.find((r) => r.strike === maxPain)?.PE;
  const premiumRatio =
    ceMaxRow?.ltp > 0 ? (peMaxRow?.ltp / ceMaxRow?.ltp).toFixed(2) : "-";

  const builtUpStyles = (signal) => {
    switch (signal) {
      case "LB":
        return { bg: "#d4f7e6", color: "#008A3E" };
      case "SB":
        return { bg: "#ffd4d4", color: "#C53030" };
      case "SC":
        return { bg: "#dce8ff", color: "#0047FF" };
      case "LW":
        return { bg: "#ffeac7", color: "#C68A14" };
      default:
        return { bg: "#f2f2f2", color: "#444" };
    }
  };
  function getBuiltUp(changeInOI, priceChange) {
    if (changeInOI > 0 && priceChange > 0) return "LB"; // Long Built-Up
    if (changeInOI > 0 && priceChange < 0) return "SB"; // Short Built-Up
    if (changeInOI < 0 && priceChange > 0) return "SC"; // Short Covering
    if (changeInOI < 0 && priceChange < 0) return "LW"; // Long Unwinding
    return "-";
  }
  const ceMaxRowBuiltUp = getBuiltUp(ceMaxRow?.oiChange, ceMaxRow?.ltpPercent);

  const peMaxRowBuiltUp = getBuiltUp(peMaxRow?.oiChange, peMaxRow?.ltpPercent);

  const builtUpStyleCE = builtUpStyles(ceMaxRowBuiltUp);
  const builtUpStylePE = builtUpStyles(peMaxRowBuiltUp);

  const getPCRSentiment = (pcr) => {
    let sentiment;
    let color; // Text color (dark shade)
    let bgColor; // Background (light shade)

    if (pcr < 0.7) {
      sentiment = "Bearish";
      color = "#C53030"; // Strong red
      bgColor = "#ffd4d4"; // Light red background
    } else if (pcr >= 0.7 && pcr <= 1.0) {
      sentiment = "Neutral";
      color = "#fbbf24";
      bgColor = "#EAEAEA"; // Light gray background
    } else if (pcr > 1.0 && pcr <= 1.3) {
      sentiment = "Bullish";
      color = "#008A3E"; // Dark green
      bgColor = "#d4f7e6"; // Light green background
    } else {
      sentiment = "Overly Bullish (Contrarian Risk)";
      color = "#856404"; // Golden/Brown text
      bgColor = "#FFF3CD"; // Soft yellow background
    }

    return { sentiment, color, bgColor };
  };
  ///ltp put and call based sentiment
  const getPremiumSentiment = (ratio) => {
    const r = Number(ratio);

    if (r > 1.3) {
      return { label: "Bearish Sentiment", bg: "#ffd4d4", color: "#C53030" };
    }

    if (r < 0.8) {
      return { label: "Bullish Sentiment", bg: "#d4f7e6", color: "#008A3E" };
    }

    return { label: "Neutral", bg: "#f2f2f2", color: "#555" };
  };
  const premiumSentiment = getPremiumSentiment(premiumRatio);

  const pcrSentimentColor = getPCRSentiment(pcr?.value);
  const prepareRowsForSave = () => {
    // return rows.map((row) => ({
    //   symbol: activeSymbol,
    //   expiry: selectedExpiry,
    //   strike: row.strike,

    //   call_oi: row.CE?.oi ?? null,
    //   call_volume: row.CE?.volume ?? null,
    //   call_iv: row.CE?.iv ?? null,
    //   call_ltp: row.CE?.ltp ?? null,
    //   call_ltp_percent: row.CE?.ltpPercent ?? null,

    //   put_ltp: row.PE?.ltp ?? null,
    //   put_ltp_percent: row.PE?.ltpPercent ?? null,
    //   put_iv: row.PE?.iv ?? null,
    //   put_volume: row.PE?.volume ?? null,
    //   put_oi: row.PE?.oi ?? null,
    // }));
    return rows.map((row) => {
      const ceOI = row.CE?.oi || 0;
      const peOI = row.PE?.oi || 0;

      const rowPCR = ceOI > 0 ? peOI / ceOI : null;
      const premiumRatio = row.CE?.ltp > 0 ? row.PE?.ltp / row.CE?.ltp : null;

      const ceBuiltUp = row.CE
        ? getBuiltUp(row.CE.oiChange, row.CE.ltpPercent)
        : null;

      const peBuiltUp = row.PE
        ? getBuiltUp(row.PE.oiChange, row.PE.ltpPercent)
        : null;

      return {
        symbol: symbol,
        expiry: selectedExpiry,
        strike: row.strike,

        call_oi: row.CE?.oi ?? null,
        call_oi_percent: row.CE?.oiPercent ?? null,
        call_volume: row.CE?.volume ?? null,
        call_iv: row.CE?.iv ?? null,
        call_ltp: row.CE?.ltp ?? null,
        call_ltp_percent: row.CE?.ltpPercent ?? null,
        call_buildup: ceBuiltUp,

        put_ltp: row.PE?.ltp ?? null,
        put_ltp_percent: row.PE?.ltpPercent ?? null,
        put_iv: row.PE?.iv ?? null,
        put_volume: row.PE?.volume ?? null,
        put_oi: row.PE?.oi ?? null,
        put_oi_percent: row.PE?.oiPercent ?? null,
        put_buildup: peBuiltUp,

        row_pcr: rowPCR,
        premium_ratio: premiumRatio,
      };
    });
  };
  console.log("Rows to save:", prepareRowsForSave());

  //handle save for save snapshot button
  const handleSave = async () => {
    try {
      const payload = {
        // symbol: activeSymbol,
        symbol: symbol,
        expiry: selectedExpiry,
        underlying,
        rows: prepareRowsForSave(),
      };

      await saveOptionChain(payload);

      setIsSaved(true);

      alert("Option chain snapshot saved successfully");
    } catch (err) {
      alert("Save failed");
    }
  };

  //   if (error) return <p>{error}</p>;
  //   if (!meta) return <p>Loading…</p>;
  const ceMaxOI = rows && Math.max(...rows?.map((item) => item.CE?.oi || 0));

  const peMaxOI = rows && Math.max(...rows.map((item) => item.PE?.oi || 0));
  console.log("CEMAX", ceMaxOI);
  console.log("peMAx", peMaxOI);
  const getPCRBg = (value) => {
    if (value < 0.7) return { bg: "#ffd4d4", color: "#C53030" }; // Bearish
    if (value <= 1.0) return { bg: "#f2f2f2", color: "#6b7280" }; // Neutral
    return { bg: "#d4f7e6", color: "#008A3E" }; // Bullish
  };

  const getStrengthBg = (value) => {
    if (value > 60) return { bg: "#d4f7e6", color: "#008A3E" };
    if (value < -60) return { bg: "#ffd4d4", color: "#C53030" };
    return { bg: "#f2f2f2", color: "#6b7280" };
  };
  const getCOIPCRBg = (value) => {
    if (value < 0.7) return { bg: "#ffd4d4", color: "#C53030" };
    if (value <= 1.0) return { bg: "#f2f2f2", color: "#6b7280" };
    return { bg: "#d4f7e6", color: "#008A3E" };
  };

  const getCOIStrengthBg = (value) => {
    if (value > 60) return { bg: "#d4f7e6", color: "#008A3E" };
    if (value < -60) return { bg: "#ffd4d4", color: "#C53030" };
    return { bg: "#f2f2f2", color: "#6b7280" };
  };
  const BUILT_UP_META = {
    LB: {
      label: "Long Built-Up",
      signal: "Bullish",
      description: "Open Interest ↑ and Price ↑",
      color: "#008A3E",
      bg: "#D4F7E6",
    },
    SB: {
      label: "Short Built-Up",
      signal: "Bearish",
      description: "Open Interest ↑ and Price ↓",
      color: "#C53030",
      bg: "#FFE1E1",
    },
    SC: {
      label: "Short Covering",
      signal: "Bullish",
      description: "Open Interest ↓ and Price ↑",
      color: "#0047FF",
      bg: "#E6EEFF",
    },
    LW: {
      label: "Long Unwinding",
      signal: "Bearish",
      description: "Open Interest ↓ and Price ↓",
      color: "#C68A14",
      bg: "#FFF3CD",
    },
  };
  const ceBuiltUp = getBuiltUp(ceMaxRow?.oiChange, ceMaxRow?.ltpPercent);
  const peBuiltUp = getBuiltUp(peMaxRow?.oiChange, peMaxRow?.ltpPercent);

  const ceBuiltUpMeta = BUILT_UP_META[ceBuiltUp];
  const peBuiltUpMeta = BUILT_UP_META[peBuiltUp];
  const getCOIPCRStyle = (value) => {
    if (value > 1.2) {
      return { background: "#d4f7e6", color: "#008A3E" };
    }
    if (value < 0.8) {
      return { background: "#ffd4d4", color: "#C53030" };
    }
    return { background: "#e8eadf", color: "#444" };
  };

  // 🔹 COI Strength % color (as per NiftyInvest logic)
  const getCOIStrengthStyle = (value) => {
    if (value > 60) {
      return { background: "#d4f7e6", color: "#008A3E" }; // Bullish
    }
    if (value < -60) {
      return { background: "#ffd4d4", color: "#C53030" }; // Bearish
    }
    return { background: "#e8eadf", color: "#444" }; // Neutral
  };
  // 🔹 OI Strength % color (TOTAL OI based)
  const getOIStrengthStyle = (value) => {
    if (value > 60) {
      return { background: "#d4f7e6", color: "#008A3E" }; // Bullish
    }
    if (value < -60) {
      return { background: "#ffd4d4", color: "#C53030" }; // Bearish
    }
    return { background: "#e8eadf", color: "#444" }; // Neutral
  };
  const handleExportCSV = () => {
    if (!isSaved) {
      alert("⚠ Please save snapshot before exporting");
      return;
    }

    downloadOptionCSV(symbol, selectedExpiry);
  };

  const handleExportExcel = () => {
    if (!isSaved) {
      alert("⚠ Please save snapshot before exporting");
      return;
    }

    downloadOptionExcel(symbol, selectedExpiry);
  };
  const atmStrike = useMemo(() => {
    if (!rows?.length || !underlying) return null;

    return rows.reduce((closest, row) => {
      const diff = Math.abs(row.strike - underlying);

      if (!closest || diff < Math.abs(closest.strike - underlying)) {
        return row;
      }

      return closest;
    }, null)?.strike;
  }, [rows, underlying]);
  useEffect(() => {
    if (!atmRef.current) return;

    // Small delay to let the DOM render the table rows
    const timer = setTimeout(() => {
      atmRef.current.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }, 300);

    return () => clearTimeout(timer);
  }, [atmStrike, selectedExpiry, formattedSymbol]);
  const atmRow = rows.find((r) => r.strike === atmStrike);
  const atmPremiumRatio =
    atmRow?.CE?.ltp > 0 ? (atmRow?.PE?.ltp / atmRow?.CE?.ltp).toFixed(2) : "-";
  const atmPremiumSentiment = getPremiumSentiment(atmPremiumRatio);
  return (
    <div>
      <div className="back-export-files">
        <div className="back-btn">
          <button className="rec-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>

        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <button className="rec-btn" onClick={handleSave}>
            Save Snapshot
          </button>

          <button
            className="rec-btn"
            onClick={handleExportCSV}
            // disabled={!isSaved}
          >
            Export CSV
          </button>

          <button
            className="rec-btn"
            onClick={handleExportExcel}
            // disabled={!isSaved}
          >
            Export Excel
          </button>
        </div>
      </div>

      <div className="pcr-top-dropdown">
        <div className="select-option dropdown pcr-option">
          <label>Expiry Dates</label>

          <select
            value={selectedExpiry || ""}
            onChange={(e) => setExpiry(e.target.value)}
          >
            {expiries.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
        <span>OR</span>
        <div className="select-option dropdown pcr-option">
          <label>Strike</label>
          <select
            onChange={handleStrikeChange}
            value={selectedStrike || ""}
            style={
              {
                // fontWeight: 700,
              }
            }
          >
            <option value="">Select</option>
            <option
              value=""
              onClick={() => {
                setSelectedExpiry("");
                setSelectedStrike("");
              }}
            >
              Default
            </option>
            {strikePrices?.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* {error && !optionData && (
        <div
          style={{
            marginTop: "20px",
            padding: "14px",
            borderLeft: "5px solid #dc2626",
            background: "#fee2e2",
            color: "#7f1d1d",
            fontWeight: 600,
            borderRadius: "8px",
          }}
        >
          ❌ Option Chain data not available
        </div>
      )} */}

      {error && !loading && !optionData && (
        <div className="option-error">{error}</div>
      )}

      {loading && (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            // color: "white",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      )}
      {!loading &&
        optionData &&
        Object.keys(optionData?.data?.oc || {}).length > 0 && (
          <div>
            {/* <div
              className="grid-1"
              style={{
                
                display: "flex",
                
                gap: "10px",
                textAlign: "left",
                marginTop: "10px",
                boxShadow: "rgba(0, 0, 0, 0.4) 0px 4px 12px",
              }}
            >
              <p
              
              >
                Company Name - {companyName}
              </p>
              <p>Stock Symbol - {symbol}</p>
              <p>
                LTP:
                <span style={{ fontWeight: "700", color: "#00b3ff" }}>
                  {" "}
                  {underlying}
                </span>
              </p>

              <p>
                Max Pain:{" "}
                <span style={{ fontWeight: "700", color: "#00e1b1" }}>
                  {maxPain}
                </span>
              </p>

              <p>
                PCR:{" "}
                <strong style={{ color: pcrSentimentColor.color }}>
                  {pcr?.value}
                </strong>
              </p>

              <p>
                Signal:{" "}
                <strong style={{ color: pcrSentimentColor.color }}>
                  {" "}
                  {pcrSentimentColor.sentiment}
                </strong>
              </p>
            </div> */}
            <div
              className="grid-1"
              style={{
                // display: "flex",
                // flexDirection: "column",
                gap: "10px",
                textAlign: "left",
                marginTop: "10px",
                boxShadow: "rgba(0, 0, 0, 0.4) 0px 4px 12px",
              }}
            >
              <p>
                <p>{companyName}</p>

                <span className="stock-tag" style={{ width: "max-content" }}>
                  {symbol}
                </span>
              </p>
              <p>
                LTP
                <span
                  style={{
                    fontWeight: "700",
                    // color: "#00b3ff",
                    backgroundColor: " #e6f0ff",
                    color: " #0062ff",
                    padding: "4px 10px",
                    borderRadius: "8px",
                    width: "max-content",
                  }}
                >
                  {" "}
                  {underlying}
                </span>
              </p>

              <p>
                Max Pain{" "}
                <span
                  style={{
                    fontWeight: "700",
                    color: "#008A3E",
                    background: "rgb(212, 247, 230)",

                    padding: "4px 10px",
                    borderRadius: "8px",
                    width: "max-content",
                  }}
                >
                  {maxPain}
                </span>
              </p>
              <p>
                ATM Put/Call Premium Ratio
                <span
                  style={{
                    background: atmPremiumSentiment.bg,
                    color: atmPremiumSentiment.color,
                    padding: "4px 10px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    width: "max-content",
                  }}
                >
                  {atmPremiumRatio} ({atmPremiumSentiment.label})
                </span>
              </p>

              <p>
                PCR Signal{" "}
                <strong
                  style={{
                    color: pcrSentimentColor.color,
                    background: pcrSentimentColor.bgColor,
                    width: "max-content",
                    padding: "4px 10px",
                    borderRadius: "8px",
                  }}
                >
                  {" "}
                  {pcrSentimentColor.sentiment}
                </strong>
              </p>
            </div>
            <div className="pcr-grid pcr-grid-layout">
              {/* <div className="grid built-up-grid">
                <div
                  style={{
                    borderRadius: "12px",
                    padding: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.4) 0px 4px 12px",
                    borderLeft: "4px solid #047cc2",
                  }}
                >
                  <h1
                    style={{
                      // color: "white",
                      fontWeight: "800",
                      textAlign: "left",
                      fontSize: "13px",
                    }}
                  >
                    {" "}
                    Built Up Abbreviation and Colors
                  </h1>
                  <ul
                    style={{
                      listStyleType: "none",
                      paddingLeft: 0,
                      // marginTop: "20px",
                      textAlign: "left",
                      fontSize: "12px",
                    }}
                  >
                    <li style={{ color: "#008A3E", marginBottom: "6px" }}>
                      <strong>LB</strong> – Long Built-Up (OI ↑ & Price ↑)
                    </li>

                    <li style={{ color: "#C53030", marginBottom: "6px" }}>
                      <strong>SB</strong> – Short Built-Up (OI ↑ & Price ↓)
                    </li>

                    <li style={{ color: "#0047FF", marginBottom: "6px" }}>
                      <strong>SC</strong> – Short Covering (OI ↓ & Price ↑)
                    </li>

                    <li style={{ color: "#C68A14", marginBottom: "6px" }}>
                      <strong>LW</strong> – Long Unwinding (OI ↓ & Price ↓)
                    </li>
                  </ul>
                </div>
              </div> */}
              <div className="ce-pe">
                <div className="ce-pe1">
                  <div>
                    <h3>Ltp ({maxPain} CE)</h3>

                    <div
                      className="ce-pe2"
                      style={{
                        background:
                          ceMaxRow?.ltpPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                        color:
                          ceMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {ceMaxRow?.ltp ?? "-"}{" "}
                      {ceMaxRow?.ltpPercent >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {ceMaxRow?.ltpPercent !== undefined
                          ? ceMaxRow.ltpPercent.toFixed(2) + "%"
                          : "-"}
                      </span>
                    </div>
                  </div>

                  <div className="sub-grid">
                    <h3>Open Interest</h3>

                    <div
                      className="ce-pe2"
                      style={{
                        background:
                          ceMaxRow?.oiPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                        color: ceMaxRow?.oiPercent >= 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {formatNumber(ceMaxRow?.oi) ?? "-"}{" "}
                      {ceMaxRow?.oiPercent >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {ceMaxRow?.oiPercent !== undefined
                          ? ceMaxRow.oiPercent.toFixed(2) + "%"
                          : "-"}
                      </span>
                    </div>
                  </div>

                  <div className="sub-grid">
                    <h3>Built Up</h3>

                    <div
                      className="ce-pe2 builtup-box"
                      style={{
                        backgroundColor: ceBuiltUpMeta?.bg || "#f2f2f2",
                        color: ceBuiltUpMeta?.color || "#444",
                        position: "relative",
                        cursor: "pointer",
                      }}
                    >
                      {ceBuiltUp}

                      {/* 🔹 Hover tooltip */}
                      {ceBuiltUpMeta && (
                        <div className="builtup-tooltip">
                          <strong>{ceBuiltUpMeta.label}</strong>
                          <div>{ceBuiltUpMeta.description}</div>
                          <div>
                            Signal:{" "}
                            <span
                              style={{
                                fontWeight: "bold",
                                color:
                                  ceBuiltUpMeta.signal === "Bullish"
                                    ? "#008A3E"
                                    : "#C53030",
                              }}
                            >
                              {ceBuiltUpMeta.signal}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="ce-pe1">
                  <div>
                    <h3>Ltp ({maxPain} PE)</h3>

                    <div
                      className="ce-pe2"
                      style={{
                        background:
                          peMaxRow?.ltpPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                        color:
                          peMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {peMaxRow?.ltp ?? "-"}{" "}
                      {peMaxRow?.ltpPercent >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {peMaxRow?.ltpPercent !== undefined
                          ? peMaxRow.ltpPercent.toFixed(2) + "%"
                          : "-"}
                      </span>
                    </div>
                  </div>

                  {/* OI box */}
                  <div className="sub-grid">
                    <h3>Open Interest</h3>
                    {/* <div
                className="ce-pe2"
                style={{
                 
                  background:
                    peMaxRow?.pchangeinOpenInterest >= 0
                      ? "#d4f7e6"
                      : "#ffd4d4",
                  
                  color:
                    peMaxRow?.pchangeinOpenInterest >= 0
                      ? "#008A3E"
                      : "#C53030",
                }}
              >
                {formatNumber(peMaxRow?.openInterest) ?? "-"}
                {peMaxRow?.pchangeinOpenInterest >= 0 ? (
                  <IoMdTrendingUp />
                ) : (
                  <IoMdTrendingDown />
                )}
                <span style={{ opacity: 0.8 }}>
                  {peMaxRow?.pchangeinOpenInterest.toFixed(2) + "%" ?? "-"}
                </span>
              </div> */}
                    <div
                      className="ce-pe2"
                      style={{
                        background:
                          peMaxRow?.oiPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                        color: peMaxRow?.oiPercent >= 0 ? "#008A3E" : "#C53030",
                      }}
                    >
                      {formatNumber(peMaxRow?.oi) ?? "-"}
                      {peMaxRow?.oiPercent >= 0 ? (
                        <IoMdTrendingUp />
                      ) : (
                        <IoMdTrendingDown />
                      )}
                      <span style={{ opacity: 0.8 }}>
                        {peMaxRow?.oiPercent !== undefined
                          ? peMaxRow.oiPercent.toFixed(2) + "%"
                          : "-"}
                      </span>
                    </div>
                  </div>
                  {/* Old code for pe without hover */}
                  {/* <div className="sub-grid">
                  <h3>Built Up</h3>
                  <div
                    className="ce-pe2"
                    style={{
                      backgroundColor: builtUpStylePE.bg,
                      color: builtUpStylePE.color,
                    }}
                  >
                    {peMaxRowBuiltUp}
                  </div>
                </div> */}
                  <div className="sub-grid">
                    <h3>Built Up</h3>

                    <div
                      className="ce-pe2 builtup-box"
                      style={{
                        backgroundColor: peBuiltUpMeta?.bg || "#f2f2f2",
                        color: peBuiltUpMeta?.color || "#444",
                        position: "relative",
                        cursor: "pointer",
                      }}
                    >
                      {peBuiltUp}

                      {peBuiltUpMeta && (
                        <div className="builtup-tooltip">
                          <strong>{peBuiltUpMeta.label}</strong>
                          <div>{peBuiltUpMeta.description}</div>
                          <div>
                            Signal:{" "}
                            <span
                              style={{
                                fontWeight: "bold",
                                color:
                                  peBuiltUpMeta.signal === "Bullish"
                                    ? "#008A3E"
                                    : "#C53030",
                              }}
                            >
                              {peBuiltUpMeta.signal}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* <div
                              style={{
                                padding: "10px 12px",
                                borderRadius: "8px",
                                fontWeight: "700",
                                fontSize: "15px",
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: builtUpSentimentPE.bg,
                                color: builtUpSentimentPE.color,
                                marginTop: "1rem",
                              }}
                            >
                              {builtUpSentimentPE?.label ?? "-"}
                            </div> */}
                </div>
              </div>

              <div
                className="grid  built-up-grid built-mobile"
                style={{
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
                }}
              >
                <div className="pcr-box">
                  <div className="pcr-inner-box box-label">
                    <div className="pcr-label">Put OI</div>
                    <div
                      className="value red"
                      style={{
                        background: "#ffd4d4",
                        color: "#C53030",
                        marginTop: "15px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        fontWeight: "700",
                        // fontSize: "15px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {pcr.totalPutOI.toLocaleString()}
                    </div>
                  </div>

                  <div className="pcr-inner-box box-label">
                    <div className="pcr-label">Call OI</div>
                    <div
                      className="value green"
                      style={{
                        background: "#d4f7e6",
                        color: "#008A3E",
                        marginTop: "15px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        fontWeight: "700",
                        // fontSize: "15px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {pcr.totalCallOI.toLocaleString()}
                    </div>
                  </div>

                  {/* PCR */}
                  <div className="pcr-inner-box">
                    <div className="pcr-label">PCR</div>

                    {(() => {
                      const sentiment = getPCRSentiment(pcr.pcr);
                      const { bg, color } = getPCRBg(pcr?.value);
                      return (
                        <div
                          className="value"
                          style={{
                            background: bg,
                            color,

                            marginTop: "15px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            fontWeight: "700",
                            // fontSize: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {pcr?.value}

                          <span
                            className="sentiment-hover"
                            style={{ color: sentiment.color }}
                          >
                            {sentiment.label}
                          </span>
                        </div>
                      );
                    })()}
                  </div>

                  <div className="pcr-inner-box">
                    <div className="pcr-label">OI Strength%</div>

                    {(() => {
                      const sentiment = getPCRSentiment(pcr.pcr);
                      const { background, color } = getOIStrengthStyle(
                        pcr?.oiStrength,
                      );
                      return (
                        <div
                          className="value"
                          style={{
                            background,
                            color,

                            marginTop: "15px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            fontWeight: "700",
                            // fontSize: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {pcr?.oiStrength}%
                          {/* 
                          <span
                            className="sentiment-hover"
                            style={{ color: sentiment.color }}
                          >
                            {sentiment.label}
                          </span> */}
                        </div>
                      );
                    })()}
                  </div>
                </div>

                <div className="pcr-box">
                  <div className="pcr-inner-box box-label">
                    <div className="pcr-label">Put OI Chg</div>
                    <div
                      className="value red"
                      style={{
                        background: "#ffd4d4",
                        color: "#C53030",
                        marginTop: "15px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        fontWeight: "700",
                        // fontSize: "15px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {pcr?.putOIChange?.toLocaleString()}
                    </div>
                  </div>

                  <div className="pcr-inner-box box-label">
                    <div className="pcr-label">Call OI Chg</div>
                    <div
                      className="value green"
                      style={{
                        background: "#d4f7e6",
                        color: "#008A3E",
                        marginTop: "15px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        fontWeight: "700",
                        // fontSize: "15px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {pcr?.callOIChange?.toLocaleString()}
                    </div>
                  </div>

                  <div className="pcr-inner-box">
                    <div className="pcr-label">COI PCR</div>

                    {(() => {
                      // const sentiment = getCOIPCRSentiment(pcr?.coiPCR);
                      const { background, color } = getCOIPCRStyle(pcr?.coiPCR);
                      return (
                        <div
                          className="value"
                          // style={getCOIPCRStyle(pcr?.coiPCR)}
                          style={{
                            background,
                            color,
                            marginTop: "15px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            fontWeight: "700",
                            // fontSize: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {pcr?.coiPCR}
                          {/* 
                          <span
                            className="sentiment-hover"
                            style={{ color: getCOIPCRStyle(pcr?.coiPCR).color }}
                          >
                            {sentiment.label}
                          </span> */}
                        </div>
                      );
                    })()}
                  </div>

                  <div className="pcr-inner-box">
                    <div className="pcr-label">COI Strength %</div>
                    {(() => {
                      const { background, color } = getCOIStrengthStyle(
                        pcr?.coiStrength,
                      );

                      return (
                        <div
                          className="value"
                          // style={getCOIPCRStyle(pcr?.coiPCR)}
                          style={{
                            background,
                            color,
                            marginTop: "15px",
                            padding: "10px 12px",
                            borderRadius: "8px",
                            fontWeight: "700",
                            // fontSize: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {pcr?.coiStrength}%
                          {/* 
                          <span
                            className="sentiment-hover"
                            style={{ color: getCOIPCRStyle(pcr?.coiPCR).color }}
                          >
                            {sentiment.label}
                          </span> */}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>

              <div className="grid call-grid">
                <div className="sub-grid">
                  <h3>Ltp ({maxPain} CE)</h3>

                  <div
                    style={{
                      background:
                        ceMaxRow?.ltpPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: ceMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {ceMaxRow?.ltp ?? "-"}{" "}
                    {ceMaxRow?.ltpPercent >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {ceMaxRow?.ltpPercent !== undefined
                        ? ceMaxRow.ltpPercent.toFixed(2) + "%"
                        : "-"}
                    </span>
                  </div>
                </div>

                <div className="sub-grid">
                  <h3>Open Interest</h3>
                  <div
                    style={{
                      background:
                        ceMaxRow?.oiPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: ceMaxRow?.oiPercent >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {formatNumber(ceMaxRow?.oi) ?? "-"}{" "}
                    {ceMaxRow?.oiPercent >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {ceMaxRow?.oiPercent !== undefined
                        ? ceMaxRow.oiPercent.toFixed(2) + "%"
                        : "-"}
                    </span>
                  </div>
                </div>
                {/* Old code without hover */}
                {/* <div className="sub-grid">
                <h3>Built Up</h3>
                <div
                  style={{
                    backgroundColor: builtUpStyleCE.bg,
                    color: builtUpStyleCE.color,
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {ceMaxRowBuiltUp}
                </div>
              </div> */}
                <div className="sub-grid">
                  <h3>Built Up</h3>

                  <div
                    className="ce-pe2 builtup-box"
                    style={{
                      backgroundColor: ceBuiltUpMeta?.bg || "#f2f2f2",
                      color: ceBuiltUpMeta?.color || "#444",
                      position: "relative",
                      cursor: "pointer",
                    }}
                  >
                    {ceBuiltUp}

                    {ceBuiltUpMeta && (
                      <div className="builtup-tooltip">
                        <strong>{ceBuiltUpMeta.label}</strong>
                        <div>{ceBuiltUpMeta.description}</div>
                        <div>
                          Signal:{" "}
                          <span
                            style={{
                              fontWeight: "bold",
                              color:
                                ceBuiltUpMeta.signal === "Bullish"
                                  ? "#008A3E"
                                  : "#C53030",
                            }}
                          >
                            {ceBuiltUpMeta.signal}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="grid call-grid">
                <div className="sub-grid">
                  <h3>Ltp ({maxPain} PE)</h3>

                  <div
                    style={{
                      background:
                        peMaxRow?.ltpPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: peMaxRow?.ltpPercent >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {peMaxRow?.ltp ?? "-"}{" "}
                    {peMaxRow?.ltpPercent >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {peMaxRow?.ltpPercent !== undefined
                        ? peMaxRow.ltpPercent.toFixed(2) + "%"
                        : "-"}
                    </span>
                  </div>
                </div>

                <div className="sub-grid">
                  <h3>Open Interest</h3>
                  <div
                    style={{
                      background:
                        peMaxRow?.oiPercent >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: peMaxRow?.oiPercent >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {formatNumber(peMaxRow?.oi) ?? "-"}
                    {peMaxRow?.oiPercent >= 0 ? (
                      <IoMdTrendingUp />
                    ) : (
                      <IoMdTrendingDown />
                    )}
                    <span style={{ fontSize: "16px", opacity: 0.8 }}>
                      {peMaxRow?.oiPercent !== undefined
                        ? peMaxRow.oiPercent.toFixed(2) + "%"
                        : "-"}
                    </span>
                  </div>
                </div>
                {/* Old code without hover */}
                {/* <div className="sub-grid">
                <h3>Built Up</h3>
                <div
                  style={{
                    backgroundColor: builtUpStylePE.bg,
                    color: builtUpStylePE.color,
                    marginTop: "15px",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {peMaxRowBuiltUp}
                </div>
              </div> */}
                <div className="sub-grid">
                  <h3>Built Up</h3>

                  <div
                    className="ce-pe2 builtup-box"
                    style={{
                      backgroundColor: peBuiltUpMeta?.bg || "#f2f2f2",
                      color: peBuiltUpMeta?.color || "#444",
                      position: "relative",
                      cursor: "pointer",
                    }}
                  >
                    {peBuiltUp}

                    {peBuiltUpMeta && (
                      <div className="builtup-tooltip">
                        <strong>{peBuiltUpMeta.label}</strong>
                        <div>{peBuiltUpMeta.description}</div>
                        <div>
                          Signal:{" "}
                          <span
                            style={{
                              fontWeight: "bold",
                              color:
                                peBuiltUpMeta.signal === "Bullish"
                                  ? "#008A3E"
                                  : "#C53030",
                            }}
                          >
                            {peBuiltUpMeta.signal}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="grid call-grid">
                {/* PUT OI */}
                <div className="sub-grid">
                  <h3>Put OI</h3>

                  <div
                    style={{
                      background: "#ffd4d4",
                      color: "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {pcr?.totalPutOI?.toLocaleString() ?? "-"}
                  </div>
                </div>

                {/* CALL OI */}
                <div className="sub-grid">
                  <h3>Call OI</h3>

                  <div
                    style={{
                      background: "#d4f7e6",
                      color: "#008A3E",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {pcr?.totalCallOI?.toLocaleString() ?? "-"}
                  </div>
                </div>

                {/* PCR */}
                <div className="sub-grid">
                  <h3>PCR</h3>

                  {(() => {
                    const { bg, color } = getPCRBg(pcr?.value);
                    return (
                      <div
                        style={{
                          background: bg,
                          color,
                          marginTop: "15px",
                          padding: "10px 12px",
                          borderRadius: "8px",
                          fontWeight: "700",
                          fontSize: "15px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {pcr?.value ?? "-"}
                      </div>
                    );
                  })()}
                </div>

                {/* OI STRENGTH % */}
                <div className="sub-grid">
                  <h3>OI Strength %</h3>

                  {(() => {
                    const { background, color } = getOIStrengthStyle(
                      pcr?.oiStrength,
                    );
                    return (
                      <div
                        style={{
                          background,
                          color,
                          marginTop: "15px",
                          padding: "10px 12px",
                          borderRadius: "8px",
                          fontWeight: "700",
                          fontSize: "15px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {pcr?.oiStrength ?? 0} %
                      </div>
                    );
                  })()}
                </div>
              </div>
              <div className="grid call-grid">
                {/* PUT OI CHANGE */}
                <div className="sub-grid">
                  <h3>Put OI Chg</h3>

                  <div
                    style={{
                      background: "#ffd4d4",
                      color: "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {pcr?.putOIChange?.toLocaleString() ?? "-"}
                  </div>
                </div>

                {/* CALL OI CHANGE */}
                <div className="sub-grid">
                  <h3>Call OI Chg</h3>

                  <div
                    style={{
                      background:
                        pcr?.callOIChange >= 0 ? "#d4f7e6" : "#ffd4d4",
                      color: pcr?.callOIChange >= 0 ? "#008A3E" : "#C53030",
                      marginTop: "15px",
                      padding: "10px 12px",
                      borderRadius: "8px",
                      fontWeight: "700",
                      fontSize: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {pcr?.callOIChange?.toLocaleString() ?? "-"}
                  </div>
                </div>

                {/* COI PCR */}
                <div className="sub-grid">
                  <h3>COI PCR</h3>

                  {(() => {
                    // const { bg, color } = getCOIPCRBg(pcr?.coiPCR);
                    const { background, color } = getCOIPCRStyle(pcr?.coiPCR);
                    return (
                      <div
                        style={{
                          background,
                          color,
                          marginTop: "15px",
                          padding: "10px 12px",
                          borderRadius: "8px",
                          fontWeight: "700",
                          fontSize: "15px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {pcr?.coiPCR ?? "-"}
                      </div>
                    );
                  })()}
                </div>

                {/* COI STRENGTH % */}
                <div className="sub-grid">
                  <h3>COI Strength %</h3>

                  {(() => {
                    const { background, color } = getCOIStrengthStyle(
                      pcr?.coiStrength,
                    );
                    return (
                      <div
                        style={{
                          background,
                          color,
                          marginTop: "15px",
                          padding: "10px 12px",
                          Radius: "8px",
                          fontWeight: "700",
                          fontSize: "15px",
                          display: "flex",
                          borderRadius: "8px",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {pcr?.coiStrength ?? 0} %
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
            <div
              className="stock-table-container"
              style={{ overflowX: "auto" }}
            >
              {/* 
              
               margin: 20px auto;
    width: 100%;
    max-height: 600px;
    overflow-y: auto;
    overflow-x: auto;
    position: relative;
              */}
              <table
                className="stock-table"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  margin: "20px auto",
                  maxHeight: "600px",
                  overflowX: "auto",
                  overflowY: "auto",
                  position: "relative",
                }}
              >
                <thead>
                  <tr>
                    <th>CALL OI</th>
                    <th>CALL OI %</th>
                    <th>CALL VOL</th>
                    <th>CALL IV</th>
                    <th>CALL LTP</th>
                    <th>CALL LTP %</th>
                    <th>BUILT UP</th>

                    <th style={{ background: "#f3f3f3", color: "black" }}>
                      STRIKE
                    </th>
                    <th style={{ background: "#f3f3f3", color: "black" }}>
                      PCR
                    </th>
                    <th>BUILT UP</th>
                    <th>PUT LTP</th>
                    <th>PUT LTP %</th>
                    <th>PUT IV</th>
                    <th>PUT VOL</th>
                    <th>PUT OI %</th>
                    <th>PUT OI</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRows?.map((row, idx) => {
                    const ceOI = row.CE?.oi || 0;
                    const peOI = row.PE?.oi || 0;
                    const rowPCR = ceOI > 0 ? (peOI / ceOI).toFixed(2) : "-";
                    const ceBuiltUp = row.CE
                      ? getBuiltUp(row.CE.oiChange, row.CE.ltpPercent)
                      : "-";

                    const peBuiltUp = row.PE
                      ? getBuiltUp(row.PE.oiChange, row.PE.ltpPercent)
                      : "-";
                    return (
                      // <tr key={idx}>
                      <tr
                        key={idx}
                        ref={row.strike === atmStrike ? atmRef : null}
                        style={{
                          backgroundColor:
                            row.strike === atmStrike
                              ? "rgba(37, 99, 235, 0.08)"
                              : "transparent",
                        }}
                      >
                        {/* ===== CALL ===== */}
                        <td
                          style={{
                            backgroundColor:
                              row?.CE?.oi === ceMaxOI
                                ? "#2fd18a"
                                : "transparent",
                            fontWeight:
                              row?.CE?.oi === ceMaxOI ? "bold" : "normal",
                            borderRadius: "10px",
                            padding: "1rem",
                          }}
                        >
                          {row.CE?.oi || "-"}
                        </td>

                        <td
                          style={{
                            color:
                              row.CE?.oiPercent > 0
                                ? "#2fd18a"
                                : row.CE?.oiPercent < 0
                                  ? "#ff4d4d"
                                  : "#999",
                            fontWeight: 600,
                          }}
                        >
                          {row.CE?.oiPercent ? `${row.CE.oiPercent}%` : "-"}
                        </td>

                        <td>{row.CE?.volume || "-"}</td>
                        <td>{row.CE?.iv ? row.CE.iv.toFixed(2) : "-"}</td>
                        <td>{row.CE?.ltp || "-"}</td>

                        <td
                          style={{
                            color:
                              row.CE?.ltpPercent > 0
                                ? "#2fd18a"
                                : row.CE?.ltpPercent < 0
                                  ? "#ff4d4d"
                                  : "#999",
                            fontWeight: 600,
                          }}
                        >
                          {row.CE?.ltpPercent ? `${row.CE.ltpPercent}%` : "-"}
                        </td>
                        <td style={{ color: builtUpStyles(ceBuiltUp).color }}>
                          {" "}
                          {ceBuiltUp}
                        </td>

                        {/* ===== STRIKE ===== */}
                        <td
                          style={{
                            fontWeight: 700,
                            color: row?.strike === maxPain ? "white" : "black",
                            backgroundColor:
                              row?.strike === maxPain ? "#2563eb" : "",
                            borderRadius: "10px",
                            padding: "1rem",
                          }}
                        >
                          {row.strike}
                        </td>

                        {/* ===== PCR ===== */}
                        <td style={{ fontWeight: 700 }}>{rowPCR}</td>
                        <td style={{ color: builtUpStyles(peBuiltUp).color }}>
                          {peBuiltUp}
                        </td>

                        {/* ===== PUT ===== */}
                        <td>{row.PE?.ltp || "-"}</td>

                        <td
                          style={{
                            color:
                              row.PE?.ltpPercent > 0
                                ? "#2fd18a"
                                : row.PE?.ltpPercent < 0
                                  ? "#ff4d4d"
                                  : "#999",
                            fontWeight: 600,
                          }}
                        >
                          {row.PE?.ltpPercent ? `${row.PE.ltpPercent}%` : "-"}
                        </td>

                        <td>{row.PE?.iv ? row.PE.iv.toFixed(2) : "-"}</td>
                        <td>{row.PE?.volume || "-"}</td>

                        <td
                          style={{
                            color:
                              row.PE?.oiPercent > 0
                                ? "#2fd18a"
                                : row.PE?.oiPercent < 0
                                  ? "#ff4d4d"
                                  : "#999",
                            fontWeight: 600,
                          }}
                        >
                          {row.PE?.oiPercent ? `${row.PE.oiPercent}%` : "-"}
                        </td>

                        <td
                          style={{
                            backgroundColor:
                              row?.PE?.oi === peMaxOI
                                ? "#ff4d4d"
                                : "transparent",
                            fontWeight:
                              row?.PE?.oi === peMaxOI ? "bold" : "normal",
                            borderRadius: "10px",
                            padding: "1rem",
                          }}
                        >
                          {row.PE?.oi || "-"}
                        </td>
                      </tr>
                    );
                  })}

                  {/* ✅ TOTAL ROW (OUTSIDE map) */}
                  <tr className="final-row-bottom">
                    <td>{formatNumber(totalCallOI)}</td>
                    <td></td>
                    <td>{totCEVol || "-"}</td>
                    <td></td>
                    <td></td>
                    <td></td>

                    <td style={{ fontWeight: 700 }}>Total</td>
                    <td
                      style={{
                        color:
                          totalPutOI / totalCallOI < 0.5
                            ? "#ff4d4d"
                            : totalPutOI / totalCallOI > 1.5
                              ? "#2fd18a"
                              : "#e6e6e6",
                        fontWeight: "bold",
                        padding: "6px",
                        textAlign: "center",
                      }}
                    >
                      {(totalPutOI / totalCallOI).toFixed(2)}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{totPEVol || "-"}</td>
                    <td></td>
                    <td>{formatNumber(totalPutOI)}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="chart">
              <MaxPainChart
                processed={optionData}
                underlying={underlying}
                maxPain={maxPain}
              />
            </div>
          </div>
        )}
    </div>
  );
};

export default OptionPage;
